<template>
  <div>
    <consultation-prescription-record v-if="isMakuang"
      :consultation="consultationPrescription"
      :printWithDailyDosage="printWithDailyDosage"
      :status="printStatus"
    />
    <tcm-consultation-prescription-record v-else
      :consultation="consultationPrescription"
      :printWithDailyDosage="printWithDailyDosage"
      :status="printStatus"
    />
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import ConsultationPrescriptionRecord from '@/components/TCMConsultation/Print/ConsultationPrescriptionRecord.vue';
import TcmConsultationPrescriptionRecord from '@/components/TCMConsultation/Print/TCMConsultationPrescriptionRecord.vue';
import constant from '@/services/constant';

const { PRINT_STATUS } = constant;

export default {
  name: 'TcmPrintPrescription',
  components: {
    ConsultationPrescriptionRecord,
    TcmConsultationPrescriptionRecord,
  },
  computed: {
    ...mapGetters('config', {
      featureFlags: 'featureFlags',
    }),
    printWithDailyDosage() {
      const { printWithDailyDosage } = this.$route.query;
      return printWithDailyDosage && printWithDailyDosage === 'true';
    },
    isMakuang() {
      return this.featureFlags.isMaKuang;
    },
  },
  data() {
    return {
      consultationPrescription: {},
      printStatus: PRINT_STATUS.PRINTING,
    };
  },
  methods: {
    ...mapActions('print', ['getTcmConsultationPrescriptionById']),
    async preparePrescriptionInConsultationToPrint() {
      try {
        const { consultation } = this.$route.query;
        if (consultation) {
          this.consultationPrescription = await this.getTcmConsultationPrescriptionById(consultation);
          this.printStatus = PRINT_STATUS.PRINTED;
        }
      } catch (error) {
        this.consultationPrescription = {};
        this.printStatus = PRINT_STATUS.FAILED;
      }
    },
    triggerPrint() {
      setTimeout(() => {
        window.print();
      }, 2000);
    },
  },
  mounted() {
    this.preparePrescriptionInConsultationToPrint()
      .then(() => this.triggerPrint())
      .catch(() => this.triggerPrint());
  },
};
</script>
